import store from "@/state/store";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
          next();
        } else {
          // Continue to the login page
          next();
        }
      }}},
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/account/register.vue"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      }}},
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      }}},
  {
    path: "/",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true},
    // component: () => import("../views/dashboard/marine-biodiversity/index")},
    component: () => import("../views/dashboard/species-conservation/index")},

  {
    path: "/pages/shapefileupload",
    name: "shapefileupload",
    meta: {
      title: "Shapefiles Upload", authRequired: true},
    component: () => import("../views/pages/ShapefileUpload")},
  {
    path: "/dashboard/marine-biodiversity",
    name: "dashboard-marine-biodiversity",
    meta: {
      title: "Marine Biodiversity", authRequired: true},
    component: () => import("../views/dashboard/marine-biodiversity/index")},
  {
    path: "/dashboard/ecosystem-overview",
    name: "dashboard-ecosystem-overview",
    meta: {
      title: "Ecosystem Overview", authRequired: true},
    component: () => import("../views/dashboard/ecosystem-overview/index")},
  {
    path: "/dashboard/species-conservation",
    name: "dashboard-species-conservation",
    meta: {
      title: "Species & Conservation", authRequired: true},
    component: () => import("../views/dashboard/species-conservation/index")},
  {
    path: "/dashboard/wildlife-tracking",
    name: "dashboard-wildlife-tracking",
    meta: {
      title: "Wildlife Tracking & Alerts", authRequired: true},
    component: () => import("../views/dashboard/wildlife-tracking/index")},
  {
    path: "/dashboard/climate-environmental",
    name: "dashboard-climate-environmental",
    meta: {
      title: "Climate & Environmental", authRequired: true},
    component: () => import("../views/dashboard/climate-environmental/index")},
  {
    path: "/dashboard/research-publications",
    name: "dashboard-research-publications",
    meta: {
      title: "Research and Publications", authRequired: true},
    component: () => import("../views/dashboard/research-publications/index")},
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout", authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.clear();
        sessionStorage.clear();
        next();
      }},
    component: () => import("../views/auth/logout/basic")
  },
  {
    path: "/cms/media",
    name: "media",
    meta: { title: "CMS Media", authRequired: true },
    component: () => import("../views/cms/media")},
  {
    path: "/cms/categories",
    name: "categories",
    meta: { title: "CMS Categories", authRequired: true },
    component: () => import("../views/cms/categories")},
  {
    path: "/cms/tags",
    name: "tags",
    meta: { title: "Tags", authRequired: true },
    component: () => import("../views/cms/tags")},
  {
    path: "/cms/posts",
    name: "posts",
    meta: { title: "Posts", authRequired: true },
    component: () => import("../views/cms/posts")},
  {
    path: "/cms/menu-items",
    name: "menu-items",
    meta: { title: "Menu Items", authRequired: true },
    component: () => import("../views/cms/menuItems")},
  {
    path: "/cms/menu-items/:menuId",
    name: "menu-items",
    meta: { title: "Menu Items", authRequired: true },
    component: () => import("../views/cms/menuItems"),
    props: true, // Pass route params as props
  },
  {
    path: "/cms/menus",
    name: "menus",
    meta: { title: "Menus", authRequired: true },
    component: () => import("../views/cms/menus")},
  {
    path: "/cms/menu-management",
    name: "cms-menu-management",
    meta: { title: "Advanced Menu Management", authRequired: true },
    component: () => import("../views/cms/menu-management")},
  {
    path: "/cms/ecosystems-content",
    name: "ecosystems-content",
    meta: { title: "Ecosystems Content", authRequired: true },
    component: () => import("../views/cms/ecosystems-content")},
  {
    path: "/cms/iucn-content",
    name: "iucn-content", 
    meta: { title: "IUCN Content", authRequired: true },
    component: () => import("../views/cms/iucn-content")},
  {
    path: "/cms/park-visits-content",
    name: "park-visits-content",
    meta: { title: "Park Visits Content", authRequired: true },
    component: () => import("../views/cms/park-visits-content")},
  {
    path: "/cms/wildlife-corridors-content",
    name: "wildlife-corridors-content",
    meta: { title: "Wildlife Corridors Content", authRequired: true },
    component: () => import("../views/cms/wildlife-corridors-content")},
  {
    path: "/cms/events-content",
    name: "events-content",
    meta: { title: "Conservation Events Content", authRequired: true },
    component: () => import("../views/cms/events-content")},
  {
    path: "/cms/innovation-content",
    name: "innovation-content",
    meta: { title: "Conservation Innovation Content", authRequired: true },
    component: () => import("../views/cms/innovation-content")},
  {
    path: "/cms/content-dashboard",
    name: "content-dashboard",
    meta: { title: "CMS Content Dashboard", authRequired: true },
    component: () => import("../views/cms/content-dashboard")},
  {
    path: "/cms/species-content",
    name: "species-content",
    meta: { title: "Species Management", authRequired: true },
    component: () => import("../views/cms/species-content")},
  {
    path: "/cms/hwc-content",
    name: "hwc-content",
    meta: { title: "Human-Wildlife Conflict Management", authRequired: true },
    component: () => import("../views/cms/hwc-content")},
  {
    path: "/example/datatable",
    name: "example-datatable",
    meta: { title: "DataTable Example", authRequired: true },
    component: () => import("../views/example/ExampleDataTable")},
  {
    path: "/apps/tickets-details",
    name: "tickets-details",
    meta: { title: "Ticket Details", authRequired: true },
    component: () => import("../views/tickets/details")},
  {
    path: "/apps/tickets-list",
    name: "tickets-list",
    meta: { title: "Tickets List", authRequired: true },
    component: () => import("../views/tickets/list")},

  {
    path: "/ui/alerts",
    name: "Alerts",
    meta: {
      title: "Alerts", authRequired: true},
    component: () => import("../views/ui/alerts")},
  {
    path: "/ui/buttons",
    name: "Buttons",
    meta: {
      title: "Buttons", authRequired: true},
    component: () => import("../views/ui/buttons")},
  {
    path: "/ui/cards",
    name: "Cards",
    meta: { title: "Cards", authRequired: true },
    component: () => import("../views/ui/cards")},
  {
    path: "/ui/carousel",
    name: "Carousel",
    meta: { title: "Carousel", authRequired: true },
    component: () => import("../views/ui/carousel")},
  {
    path: "/ui/dropdowns",
    name: "Dropdowns",
    meta: { title: "Dropdowns", authRequired: true },
    component: () => import("../views/ui/dropdowns")},
  {
    path: "/ui/grid",
    name: "Grid",
    meta: { title: "Grid", authRequired: true },
    component: () => import("../views/ui/grid")},
  {
    path: "/ui/images",
    name: "Images",
    meta: { title: "Images", authRequired: true },
    component: () => import("../views/ui/images")},
  {
    path: "/ui/modals",
    name: "Modals",
    meta: { title: "Modals", authRequired: true },
    component: () => import("../views/ui/modals")},
  {
    path: "/ui/offcanvas",
    name: "offcanvas",
    meta: { title: "Offcanvas", authRequired: true },
    component: () => import("../views/ui/offcanvas")},
  {
    path: "/ui/progress",
    name: "Progress",
    meta: { title: "Progress", authRequired: true },
    component: () => import("../views/ui/progress")},
  {
    path: "/ui/placeholders",
    name: "Placeholders",
    meta: { title: "Placeholders", authRequired: true },
    component: () => import("../views/ui/placeholders")},
  {
    path: "/ui/accordions",
    name: "accordions",
    meta: { title: "Accordions", authRequired: true },
    component: () => import("../views/ui/accordions")},
  {
    path: "/ui/tabs",
    name: "tabs",
    meta: { title: "Tabs", authRequired: true },
    component: () => import("../views/ui/tabs")},
  {
    path: "/ui/typography",
    name: "Typography",
    meta: { title: "Typography", authRequired: true },
    component: () => import("../views/ui/typography")},
  {
    path: "/ui/embed-video",
    name: "embed-video",
    meta: { title: "Embed Video", authRequired: true },
    component: () => import("../views/ui/embed-video")},
  {
    path: "/ui/ribbons",
    name: "ribbons",
    meta: { title: "Ribbons", authRequired: true },
    component: () => import("../views/ui/ribbons")},
  {
    path: "/ui/lists",
    name: "lists",
    meta: { title: "Lists", authRequired: true },
    component: () => import("../views/ui/lists")},
  {
    path: "/ui/links",
    name: "links",
    meta: { title: "Links", authRequired: true },
    component: () => import("../views/ui/links")},
  {
    path: "/ui/utilities",
    name: "utilities",
    meta: { title: "Utilities", authRequired: true },
    component: () => import("../views/ui/utilities")},
  {
    path: "/ui/notifications",
    name: "notifications",
    meta: { title: "Notifications", authRequired: true },
    component: () => import("../views/ui/notifications")},
  {
    path: "/ui/general",
    name: "General",
    meta: { title: "General", authRequired: true },
    component: () => import("../views/ui/general")},
  {
    path: "/ui/colors",
    name: "Colors",
    meta: { title: "Colors", authRequired: true },
    component: () => import("../views/ui/colors")},
  {
    path: "/ui/badges",
    name: "badges",
    meta: { title: "Badges", authRequired: true },
    component: () => import("../views/ui/badges")},
  {
    path: "/widgets",
    name: "widgets",
    meta: { title: "Widgets", authRequired: true },
    component: () => import("../views/widgets/index")},
  {
    path: "/icons/boxicons",
    name: "boxicons-icon",
    meta: { title: "Boxicons", authRequired: true },
    component: () => import("../views/icons/boxicons")},
  {
    path: "/icons/materialdesign",
    name: "Material Design",
    meta: { title: "Material Design", authRequired: true },
    component: () => import("../views/icons/materialdesign")},
  {
    path: "/icons/feather",
    name: "feather",
    meta: { title: "Feather", authRequired: true },
    component: () => import("../views/icons/feather")},
  {
    path: "/icons/lineawesome",
    name: "lineawesome",
    meta: { title: "Line Awesome", authRequired: true },
    component: () => import("../views/icons/lineawesome")},
  {
    path: "/icons/remix",
    name: "remix",
    meta: { title: "Remix", authRequired: true },
    component: () => import("../views/icons/remix")},
  {
    path: "/icons/crypto",
    name: "crypto",
    meta: { title: "Crypto", authRequired: true },
    component: () => import("../views/icons/crypto")},
  {
    path: "/tables/basic",
    name: "basic-table",
    meta: { title: "Basic Table", authRequired: true },
    component: () => import("../views/tables/basic")},
  {
    path: "/tables/gridjs",
    name: "gridjs",
    meta: { title: "Grid JS", authRequired: true },
    component: () => import("../views/tables/grid/index")},
  {
    path: "/form/advanced",
    name: "form-advanced",
    meta: { title: "Form Advance", authRequired: true },
    component: () => import("../views/forms/advanced")},
  {
    path: "/form/elements",
    name: "form-elements",
    meta: { title: "Form Elements", authRequired: true },
    component: () => import("../views/forms/elements")},
  {
    path: "/form/layouts",
    name: "Form Layouts",
    meta: { title: "Form Layouts", authRequired: true },
    component: () => import("../views/forms/layouts")},
  {
    path: "/form/editors",
    name: "Form Editors",
    meta: { title: "Form Editors", authRequired: true },
    component: () => import("../views/forms/editors")},
  {
    path: "/form/file-uploads",
    name: "File Uploads",
    meta: { title: "File Uploads", authRequired: true },
    component: () => import("../views/forms/file-uploads")},
  {
    path: "/form/validation",
    name: "Form Validation",
    meta: { title: "Form Validation", authRequired: true },
    component: () => import("../views/forms/validation")},
  {
    path: "/form/wizard",
    name: "Form Wizard",
    meta: { title: "Form Wizard", authRequired: true },
    component: () => import("../views/forms/wizard")},
  {
    path: "/form/masks",
    name: "form-mask",
    meta: { title: "Form Mask", authRequired: true },
    component: () => import("../views/forms/masks")},
  {
    path: "/form/pickers",
    name: "form-pickers",
    meta: { title: "Form Picker", authRequired: true },
    component: () => import("../views/forms/pickers")},
  {
    path: "/form/range-sliders",
    name: "form-range-slider",
    meta: { title: "Form Range Slider", authRequired: true },
    component: () => import("../views/forms/range-sliders")},
  {
    path: "/form/select",
    name: "form-select",
    meta: { title: "Form Select", authRequired: true },
    component: () => import("../views/forms/select")},
  {
    path: "/form/checkboxs-radios",
    name: "form-checkboxs-radio",
    meta: { title: "Checkboxs & Radios", authRequired: true },
    component: () => import("../views/forms/checkboxs-radios")},
  {
    path: "/landing",
    name: "landing",
    meta: { title: "Landing", authRequired: true },
    component: () => import("../views/landing/index")},
  {
    path: "/pages/roles",
    name: "roles",
    meta: { title: "Roles", authRequired: true },
    component: () => import("../views/pages/roles")},
  {
    path: "/pages/users",
    name: "users",
    meta: { title: "Users", authRequired: true },
    component: () => import("../views/pages/users")},
  {
    path: "/pages/ecosystems",
    name: "ecosystems",
    meta: { title: "Ecosystems", authRequired: true },
    component: () => import("../views/pages/ecosystems")},
  {
    path: "/pages/profile",
    name: "profile",
    meta: { title: "Profile", authRequired: true },
    component: () => import("../views/pages/profile/simple")},
  {
    path: "/pages/profile-setting",
    name: "profile-setting",
    meta: { title: "Setting", authRequired: true },
    component: () => import("../views/pages/profile/setting")},
  {
    path: "/pages/coming-soon",
    name: "coming-soon",
    meta: { title: "Comming Soon", authRequired: true },
    component: () => import("../views/pages/coming-soon")},
  {
    path: "/pages/search-results",
    name: "search-results",
    meta: { title: "Search Results", authRequired: true },
    component: () => import("../views/pages/search-results")},
  {
    path: "/blogs/list-view",
    name: "List View",
    meta: { title: "Blogs", authRequired: true },
    component: () => import("../views/pages/blogs/list-view")},
  {
    path: "/blogs/grid-view",
    name: "grid-view",
    meta: { title: "Blogs", authRequired: true },
    component: () => import("../views/pages/blogs/grid-view")},
  {
    path: "/blogs/overview",
    name: "overview",
    meta: { title: "Blogs", authRequired: true },
    component: () => import("../views/pages/blogs/overview")},
  {
    path: "/charts/chartjs",
    name: "chartjs-chart",
    meta: { title: "Chartjs", authRequired: true },
    component: () => import("../views/charts/chartjs/index")},
  {
    path: "/charts/echart",
    name: "echart",
    meta: { title: "Echarts", authRequired: true },
    component: () => import("../views/charts/echart/index")},
  {
    path: '/charts/apex-line',
    name: 'line',
    meta: {
      title: "Line Charts", authRequired: true},
    component: () => import('../views/charts/apex/line/index')
  },
  {
    path: '/charts/apex-area',
    name: 'area-chart',
    meta: {
      title: "Area Charts", authRequired: true},
    component: () => import('../views/charts/apex/area/index')
  },
  {
    path: '/charts/apex-bar',
    name: 'bar-chart',
    meta: {
      title: "Bar Charts", authRequired: true},
    component: () => import('../views/charts/apex/bar/index')
  },
  {
    path: '/charts/apex-column',
    name: 'column-chart',
    meta: {
      title: "Column Charts", authRequired: true},
    component: () => import('../views/charts/apex/column/index')
  },

  {
    path: '/charts/apex-mixed',
    name: 'mixed-chart',
    meta: {
      title: "Mixed Charts", authRequired: true},
    component: () => import('../views/charts/apex/mixed/index')
  },
  {
    path: '/charts/apex-range-area',
    name: 'range-area-chart',
    meta: {
      title: "Range Area Charts", authRequired: true},
    component: () => import('../views/charts/apex/rangearea/index')
  },
  {
    path: '/charts/apex-funnel',
    name: 'funnel-chart',
    meta: {
      title: "Funnel Charts", authRequired: true},
    component: () => import('../views/charts/apex/funnel/index')
  },
  {
    path: '/charts/apex-candlestick',
    name: 'candlestick',
    meta: {
      title: "Candlestick", authRequired: true},
    component: () => import('../views/charts/apex/candlestick/index')
  },
  {
    path: '/charts/apex-boxplot',
    name: 'boxplot',
    meta: {
      title: "Boxplot", authRequired: true},
    component: () => import('../views/charts/apex/boxplot/index')
  },
  {
    path: '/charts/apex-bubble',
    name: 'bubble',
    meta: {
      title: "Bubble Chart", authRequired: true},
    component: () => import('../views/charts/apex/bubble/index')
  },
  {
    path: '/charts/apex-scatter',
    name: 'scatter',
    meta: {
      title: "Scatter", authRequired: true},
    component: () => import('../views/charts/apex/scatter/index')
  },
  {
    path: '/charts/apex-heatmap',
    name: 'heatmap',
    meta: {
      title: "Heatmap", authRequired: true},
    component: () => import('../views/charts/apex/heatmap/index')
  },
  {
    path: '/charts/apex-treemap',
    name: 'treemap',
    meta: {
      title: "Treemap", authRequired: true},
    component: () => import('../views/charts/apex/treemap/index')
  },
  {
    path: '/charts/apex-pie',
    name: 'pie',
    meta: {
      title: "Apex Pie", authRequired: true},
    component: () => import('../views/charts/apex/pie/index')
  },
  {
    path: '/charts/apex-radialbar',
    name: 'radialbar',
    meta: {
      title: "Apex Radialbar", authRequired: true},
    component: () => import('../views/charts/apex/radiabar/index')
  },
  {
    path: '/charts/apex-radar',
    name: 'radar',
    meta: {
      title: "Apex Radar", authRequired: true},
    component: () => import('../views/charts/apex/radar/index')
  },
  {
    path: '/charts/apex-polararea',
    name: 'polararea',
    meta: {
      title: "Polararea", authRequired: true},
    component: () => import('../views/charts/apex/polararea/index')
  },
  {
    path: '/charts/apex-slope',
    name: 'slope',
    meta: {
      title: "Slope", authRequired: true},
    component: () => import('../views/charts/apex/slope/index')
  },
  {
    path: '/auth/signin-basic',
    name: 'signin-basic',
    meta: {
      title: "Signin Basic", authRequired: true},
    component: () => import('../views/auth/signin/basic')
  },
  {
    path: '/auth/signin-cover',
    name: 'signin-cover',
    meta: {
      title: "Signin Cover", authRequired: true},
    component: () => import('../views/auth/signin/cover')
  },
  {
    path: '/auth/signup-basic',
    name: 'signup-basic',
    meta: {
      title: "Signup Basic", authRequired: true},
    component: () => import('../views/auth/signup/basic')
  },
  {
    path: '/auth/signup-cover',
    name: 'signup-cover',
    meta: {
      title: "Signup Cover", authRequired: true},
    component: () => import('../views/auth/signup/cover')
  },
  {
    path: '/auth/reset-pwd-basic',
    name: 'reset-pwd-basic',
    meta: {
      title: "Reset Password", authRequired: true},
    component: () => import('../views/auth/reset/basic')
  },
  {
    path: '/auth/reset-pwd-cover',
    name: 'reset-pwd-cover',
    meta: {
      title: "Reset Password", authRequired: true},
    component: () => import('../views/auth/reset/cover')
  },
  {
    path: '/auth/create-pwd-basic',
    name: 'create-pwd-basic',
    meta: {
      title: "create Password", authRequired: true},
    component: () => import('../views/auth/create/basic')
  },
  {
    path: '/auth/create-pwd-cover',
    name: 'create-pwd-cover',
    meta: {
      title: "create Password", authRequired: true},
    component: () => import('../views/auth/create/cover')
  },
  {
    path: '/auth/lockscreen-basic',
    name: 'lock-screen-basic',
    meta: {
      title: "Lock Screen", authRequired: true},
    component: () => import('../views/auth/lockscreen/basic')
  },
  {
    path: '/auth/lockscreen-cover',
    name: 'lock-screen-cover',
    meta: {
      title: "Lock Screen", authRequired: true},
    component: () => import('../views/auth/lockscreen/cover')
  },
  {
    path: '/auth/twostep-basic',
    name: 'twostep-basic',
    meta: {
      title: "Two Step Auth", authRequired: true},
    component: () => import('../views/auth/twostep/basic')
  }, {
    path: '/auth/twostep-cover',
    name: 'twostep-cover',
    meta: {
      title: "Two Step Auth", authRequired: true},
    component: () => import('../views/auth/twostep/cover')
  },
  {
    path: '/auth/404',
    name: '404',
    meta: {
      title: "Error 404", authRequired: true},
    component: () => import('../views/auth/errors/404')
  },
  {
    path: '/auth/500',
    name: '500',
    meta: {
      title: "Error 500", authRequired: true},
    component: () => import('../views/auth/errors/500')
  },
  {
    path: '/auth/404-basic',
    name: '404-basic',
    meta: {
      title: "Error 404", authRequired: true},
    component: () => import('../views/auth/errors/404-basic')
  },
  {
    path: '/auth/404-cover',
    name: '404-cover',
    meta: {
      title: "Error 404", authRequired: true},
    component: () => import('../views/auth/errors/404-cover')
  },
  {
    path: '/auth/ofline',
    name: 'ofline',
    meta: {
      title: "Offline", authRequired: true},
    component: () => import('../views/auth/errors/ofline')
  },
  {
    path: '/auth/logout-basic',
    name: 'logout-basic',
    meta: {
      title: "Logout", authRequired: true},
    component: () => import('../views/auth/logout/basic')
  },
  {
    path: '/auth/logout-cover',
    name: 'logout-cover',
    meta: {
      title: "Logout", authRequired: true},
    component: () => import('../views/auth/logout/cover')
  },
  {
    path: '/auth/success-msg-basic',
    name: 'success-msg-basic',
    meta: {
      title: "Success Message", authRequired: true},
    component: () => import('../views/auth/success-msg/basic')
  },
  {
    path: '/auth/success-msg-cover',
    name: 'success-msg-cover',
    meta: {
      title: "Success Message", authRequired: true},
    component: () => import('../views/auth/success-msg/cover')
  },
  {
    path: "/maps/google",
    name: "Google Maps",
    meta: {
      title: "Google Maps", authRequired: true},
    component: () => import("../views/maps/google")},  {
    path: "/maps/leaflet",
    name: "Leaflet Maps",
    meta: { title: "Leaflet Maps", authRequired: true },
    component: () => import("../views/maps/leaflet/index")},

  // Conservation Management Routes
  {
    path: "/conservation/protected-areas",
    name: "protected-areas",
    meta: { title: "Protected Areas Management", authRequired: true },
    component: () => import("../views/conservation/protected-areas")},
  {
    path: "/conservation/parks-reserves",
    name: "parks-reserves",
    meta: { title: "Parks & Reserves", authRequired: true },
    component: () => import("../views/conservation/parks-reserves")},
  {
    path: "/conservation/sanctuaries",
    name: "sanctuaries",
    meta: { title: "Sanctuaries", authRequired: true },
    component: () => import("../views/conservation/sanctuaries")},
  {
    path: "/conservation/conservancies",
    name: "conservancies",
    meta: { title: "Conservancies", authRequired: true },
    component: () => import("../views/conservation/conservancies")},
  {
    path: "/conservation/geo-maps",
    name: "geo-maps",
    meta: { title: "Geo-referenced Maps", authRequired: true },
    component: () => import("../views/conservation/geo-maps")},
  {
    path: "/conservation/publications",
    name: "conservation-publications",
    meta: { title: "Publications Management", authRequired: true },
    component: () => import("../views/conservation/publications")},
  {
    path: "/conservation/ecosystems",
    name: "ecosystems",
    meta: { title: "Ecosystems", authRequired: true },
    component: () => import("../views/conservation/ecosystems")},
  {
    path: "/conservation/wildlife-corridors",
    name: "wildlife-corridors",
    meta: { title: "Wildlife Corridors", authRequired: true },
    component: () => import("../views/conservation/wildlife-corridors")},
  {
    path: "/conservation/ecologies",
    name: "ecologies",
    meta: { title: "Ecologies", authRequired: true },
    component: () => import("../views/conservation/ecologies")},

  // Ranch Management Routes
  {
    path: "/conservation/ranches",
    name: "ranch-list",
    meta: { title: "Ranch Management", authRequired: true },
    component: () => import("../views/conservation/ranches/RanchList")},
  {
    path: "/conservation/ranches/add",
    name: "ranch-add",
    meta: { title: "Add Ranch", authRequired: true },
    component: () => import("../views/conservation/ranches/RanchForm")},
  {
    path: "/conservation/ranches/edit/:id",
    name: "ranch-edit",
    meta: { title: "Edit Ranch", authRequired: true },
    component: () => import("../views/conservation/ranches/RanchForm")},
  {
    path: "/conservation/ranches/view/:id",
    name: "ranch-view",
    meta: { title: "View Ranch", authRequired: true },
    component: () => import("../views/conservation/ranches/RanchList")},
  {
    path: "/conservation/ranches/map",
    name: "ranch-map",
    meta: { title: "Ranch Map View", authRequired: true },
    component: () => import("../views/conservation/ranches/RanchMap")},

  // Biodiversity Management Routes
  {
    path: "/biodiversity/flora",
    name: "flora",
    meta: { title: "Flora Management", authRequired: true },
    component: () => import("../views/biodiversity/flora")},
  {
    path: "/biodiversity/fauna",
    name: "fauna",
    meta: { title: "Fauna Management", authRequired: true },
    component: () => import("../views/biodiversity/fauna")},
  {
    path: "/biodiversity/classification",
    name: "species-classification",
    meta: { title: "Species Classification", authRequired: true },
    component: () => import("../views/biodiversity/classification")},
  {
    path: "/biodiversity/iucn-status",
    name: "iucn-status",
    meta: { title: "IUCN Status Updates", authRequired: true },
    component: () => import("../views/biodiversity/iucn-status")},
  {
    path: "/biodiversity/population-tracking",
    name: "population-tracking",
    meta: { title: "Population Tracking", authRequired: true },
    component: () => import("../views/biodiversity/population-tracking")},
  {
    path: "/biodiversity/species-publications",
    name: "species-publications",
    meta: { title: "Species Publications", authRequired: true },
    component: () => import("../views/biodiversity/species-publications")},

  // Human-Wildlife Interface Routes
  {
    path: "/human-wildlife/incident-reports",
    name: "incident-reports",
    meta: { title: "Incident Reports", authRequired: true },
    component: () => import("../views/human-wildlife/incident-reports")},
  {
    path: "/human-wildlife/human-casualties",
    name: "human-casualties",
    meta: { title: "Human Casualties", authRequired: true },
    component: () => import("../views/human-wildlife/human-casualties")},
  {
    path: "/human-wildlife/crop-damage",
    name: "crop-damage",
    meta: { title: "Crop Damage", authRequired: true },
    component: () => import("../views/human-wildlife/crop-damage")},
  {
    path: "/human-wildlife/property-destruction",
    name: "property-destruction",
    meta: { title: "Property Destruction", authRequired: true },
    component: () => import("../views/human-wildlife/property-destruction")},
  {
    path: "/human-wildlife/hotspots",
    name: "hotspots",
    meta: { title: "Hotspots", authRequired: true },
    component: () => import("../views/human-wildlife/hotspots")},
  {
    path: "/human-wildlife/hotspot-mapping",
    name: "hotspot-mapping",
    meta: { title: "Hotspot Mapping", authRequired: true },
    component: () => import("../views/human-wildlife/hotspot-mapping")},
  {
    path: "/human-wildlife/case-filtering",
    name: "case-filtering",
    meta: { title: "Case Filtering (County/Ward)", authRequired: true },
    component: () => import("../views/human-wildlife/case-filtering")},
  {
    path: "/human-wildlife/hotspot-species-management",
    name: "hotspot-species-management",
    meta: { title: "Hotspot Species Management", authRequired: true },
    component: () => import("../views/human-wildlife/hotspot-species-management")},

  // Compensation System Routes
  {
    path: "/compensation/claims",
    name: "compensation-claims",
    meta: { title: "Compensation Claims", authRequired: true },
    component: () => import("../views/compensation/claims")},
  {
    path: "/compensation/payment-processing",
    name: "payment-processing",
    meta: { title: "Payment Processing", authRequired: true },
    component: () => import("../views/compensation/payment-processing")},
  {
    path: "/compensation/case-status",
    name: "case-status",
    meta: { title: "Case Status Tracking", authRequired: true },
    component: () => import("../views/compensation/case-status")},
  {
    path: "/compensation/regional-reports",
    name: "regional-reports",
    meta: { title: "Regional Reports", authRequired: true },
    component: () => import("../views/compensation/regional-reports")},
  // Mitigation Measures Routes
  {
    path: "/mitigation/fence-management",
    name: "fence-management",
    meta: { title: "Fence Management", authRequired: true },
    component: () => import("../views/mitigation/fence-management")},
  {
    path: "/mitigation/water-pans",
    name: "water-pans",
    meta: { title: "Water Pans", authRequired: true },
    component: () => import("../views/mitigation/water-pans")},
  {
    path: "/mitigation/problem-animal-control",
    name: "problem-animal-control",
    meta: { title: "Problem Animal Control", authRequired: true },
    component: () => import("../views/mitigation/problem-animal-control")},
  {
    path: "/mitigation/mitigation-measures",
    name: "mitigation-measures",
    meta: { title: "Mitigation Measures", authRequired: true },
    component: () => import("../views/mitigation/mitigation-measures")},

  // Education & Outreach Routes
  {
    path: "/education/wildlife-clubs",
    name: "wildlife-clubs",
    meta: { title: "Wildlife Clubs Registry", authRequired: true },
    component: () => import("../views/education/wildlife-clubs")},
  {
    path: "/education/school-programs",
    name: "school-programs",
    meta: { title: "School Programs", authRequired: true },
    component: () => import("../views/education/school-programs")},
  {
    path: "/education/youth-training",
    name: "youth-training",
    meta: { title: "Youth Training", authRequired: true },
    component: () => import("../views/education/youth-training")},
  {
    path: "/education/innovation-initiatives",
    name: "innovation-initiatives",
    meta: { title: "Innovation Initiatives", authRequired: true },
    component: () => import("../views/education/innovation-initiatives")},
  {
    path: "/education/competitions",
    name: "competitions",
    meta: { title: "Art & Essay Competitions", authRequired: true },
    component: () => import("../views/education/competitions")},
  {
    path: "/education/outdoor-learning",
    name: "outdoor-learning",
    meta: { title: "Outdoor Learning Events", authRequired: true },
    component: () => import("../views/education/outdoor-learning")},
  {
    path: "/education/habitat-restoration",
    name: "habitat-restoration",
    meta: { title: "Habitat Restoration", authRequired: true },
    component: () => import("../views/education/habitat-restoration")},

  // Community Engagement Routes
  {
    path: "/community/event-calendar",
    name: "event-calendar",
    meta: { title: "Event Calendar", authRequired: true },
    component: () => import("../views/community/event-calendar")},
  {
    path: "/community/outreach-programs",
    name: "outreach-programs",
    meta: { title: "Outreach Programs", authRequired: true },
    component: () => import("../views/community/outreach-programs")},
  {
    path: "/community/capacity-building",
    name: "capacity-building",
    meta: { title: "Capacity Building", authRequired: true },
    component: () => import("../views/community/capacity-building")},
  {
    path: "/community/calendar-events",
    name: "calendar-events",
    meta: { title: "Calendar of Events", authRequired: true },
    component: () => import("../views/community/calendar-events")},
  {
    path: "/community/wildlife-days",
    name: "wildlife-days",
    meta: { title: "Wildlife Days Events", authRequired: true },
    component: () => import("../views/community/wildlife-days")},
  {
    path: "/community/stakeholder-meetings",
    name: "stakeholder-meetings",
    meta: { title: "Stakeholder Meetings", authRequired: true },
    component: () => import("../views/community/stakeholder-meetings")},

  // Threats & Security Routes
  {
    path: "/threats/poaching-bushmeat-hotspots",
    name: "poaching-bushmeat-hotspots",
    meta: { title: "Poaching and Bushmeat Hotspots", authRequired: true },
    component: () => import("../views/threats/poaching-bushmeat-hotspots")},
  {
    path: "/threats/poaching-incidents",
    name: "poaching-incidents",
    meta: { title: "Poaching Incidents", authRequired: true },
    component: () => import("../views/threats/poaching-incidents")},
  {
    path: "/threats/arrests",
    name: "arrests",
    meta: { title: "Arrests", authRequired: true },
    component: () => import("../views/threats/arrests")},
  {
    path: "/threats/prosecution",
    name: "prosecution",
    meta: { title: "Prosecution Cases", authRequired: true },
    component: () => import("../views/threats/prosecution")},
  {
    path: "/threats/bushmeat-cases",
    name: "bushmeat-cases",
    meta: { title: "Bushmeat Cases", authRequired: true },
    component: () => import("../views/threats/bushmeat-cases")},
  {
    path: "/threats/climate-change",
    name: "climate-change",
    meta: { title: "Climate Change Data", authRequired: true },
    component: () => import("../views/threats/climate-change")},
  {
    path: "/threats/invasive-species",
    name: "invasive-species",
    meta: { title: "Invasive Species", authRequired: true },
    component: () => import("../views/threats/invasive-species")},
  {
    path: "/threats/habitat-loss",
    name: "habitat-loss",
    meta: { title: "Habitat Loss Monitoring", authRequired: true },
    component: () => import("../views/threats/habitat-loss")},
  {
    path: "/threats/water-pollution",
    name: "water-pollution",
    meta: { title: "Water Pollution Reports", authRequired: true },
    component: () => import("../views/threats/water-pollution")},
  {
    path: "/threats/plastic-pollution",
    name: "plastic-pollution",
    meta: { title: "Plastic Pollution", authRequired: true },
    component: () => import("../views/threats/plastic-pollution")},
  {
    path: "/threats/enforcement-issues",
    name: "enforcement-issues",
    meta: { title: "Enforcement Issues", authRequired: true },
    component: () => import("../views/threats/enforcement-issues")},
  {
    path: "/threats/mining-in-parks",
    name: "mining-in-parks",
    meta: { title: "Mining in Parks", authRequired: true },
    component: () => import("../views/threats/mining-in-parks")},
  {
    path: "/threats/infrastructure-conflicts",
    name: "infrastructure-conflicts",
    meta: { title: "Infrastructure Conflicts", authRequired: true },
    component: () => import("../views/threats/infrastructure-conflicts")},

  // Wildlife Economy Routes
  {
    path: "/economy/park-entry-fees",
    name: "park-entry-fees",
    meta: { title: "Park Entry Fees", authRequired: true },
    component: () => import("../views/economy/park-entry-fees")},
  {
    path: "/economy/visitor-statistics",
    name: "visitor-statistics",
    meta: { title: "Visitor Statistics", authRequired: true },
    component: () => import("../views/economy/visitor-statistics")},
  {
    path: "/economy/park-visits",
    name: "park-visits",
    meta: { title: "Park Visits", authRequired: true },
    component: () => import("../views/economy/park-visits")},
  {
    path: "/economy/tourism-analytics",
    name: "tourism-analytics",
    meta: { title: "Tourism Analytics", authRequired: true },
    component: () => import("../views/economy/tourism-analytics")},
  {
    path: "/economy/licensing",
    name: "licensing",
    meta: { title: "Licensing Management", authRequired: true },
    component: () => import("../views/economy/licensing")},
  {
    path: "/economy/access-benefit-sharing",
    name: "access-benefit-sharing",
    meta: { title: "Access & Benefit Sharing", authRequired: true },
    component: () => import("../views/economy/access-benefit-sharing")},
  {
    path: "/economy/game-farming",
    name: "game-farming",
    meta: { title: "Game Farming Permits", authRequired: true },
    component: () => import("../views/economy/game-farming")},
  {
    path: "/economy/bioprospecting",
    name: "bioprospecting",
    meta: { title: "Bioprospecting", authRequired: true },
    component: () => import("../views/economy/bioprospecting")},
  {
    path: "/economy/digital-sequence",
    name: "digital-sequence",
    meta: { title: "Digital Sequence Info", authRequired: true },
    component: () => import("../views/economy/digital-sequence")},
  {
    path: "/economy/traditional-knowledge",
    name: "traditional-knowledge",
    meta: { title: "Traditional Knowledge", authRequired: true },
    component: () => import("../views/economy/traditional-knowledge")},
  {
    path: "/economy/redd-projects",
    name: "redd-projects",
    meta: { title: "REDD++ Projects", authRequired: true },
    component: () => import("../views/economy/redd-projects")},
  {
    path: "/economy/carbon-credits",
    name: "carbon-credits",
    meta: { title: "Carbon Credits", authRequired: true },
    component: () => import("../views/economy/carbon-credits")},
  {
    path: "/economy/ecosystem-valuation",
    name: "ecosystem-valuation",
    meta: { title: "Ecosystem Valuation", authRequired: true },
    component: () => import("../views/economy/ecosystem-valuation")},
    
  // Projects & Programs Routes
  {
    path: "/projects/gok-funded",
    name: "gok-funded",
    meta: { title: "GoK Funded Projects", authRequired: true },
    component: () => import("../views/projects/gok-funded")},
  {
    path: "/projects/project-trackers",
    name: "project-trackers",
    meta: { title: "Project Trackers", authRequired: true },
    component: () => import("../views/projects/trackers")},
  {
    path: "/projects/geotagged-projects",
    name: "geotagged-projects",
    meta: { title: "Geotagged Projects", authRequired: true },
    component: () => import("../views/projects/geotagged")},
  {
    path: "/projects/infrastructure",
    name: "infrastructure",
    meta: { title: "Infrastructure Projects", authRequired: true },
    component: () => import("../views/projects/infrastructure")},
  {
    path: "/projects/impact-assessment",
    name: "impact-assessment",
    meta: { title: "Impact Assessment", authRequired: true },
    component: () => import("../views/projects/impact-assessment")},
  {
    path: "/projects/performance-indicators",
    name: "performance-indicators",
    meta: { title: "Performance Indicators", authRequired: true },
    component: () => import("../views/projects/performance-indicators")},
  {
    path: "/projects/me-reports",
    name: "me-reports",
    meta: { title: "M&E Reports", authRequired: true },
    component: () => import("../views/projects/me-reports")},

  // Stakeholder Management Routes
  {
    path: "/stakeholders/development-partners",
    name: "development-partners",
    meta: { title: "Development Partners", authRequired: true },
    component: () => import("../views/stakeholders/development-partners")},
  {
    path: "/stakeholders/government-agencies",
    name: "government-agencies",
    meta: { title: "Government Agencies", authRequired: true },
    component: () => import("../views/stakeholders/government-agencies")},
  {
    path: "/stakeholders/ngos",
    name: "ngos",
    meta: { title: "NGOs & Civil Society", authRequired: true },
    component: () => import("../views/stakeholders/ngos")},
  {
    path: "/stakeholders/private-sector",
    name: "private-sector",
    meta: { title: "Private Sector", authRequired: true },
    component: () => import("../views/stakeholders/private-sector")},
  {
    path: "/stakeholders/communities",
    name: "stakeholder-communities",
    meta: { title: "Community Groups", authRequired: true },
    component: () => import("../views/stakeholders/communities")},
  {
    path: "/stakeholders/research-institutions",
    name: "research-institutions",
    meta: { title: "Research Institutions", authRequired: true },
    component: () => import("../views/stakeholders/research-institutions")},
  {
    path: "/stakeholders/international-orgs",
    name: "international-orgs",
    meta: { title: "International Organizations", authRequired: true },
    component: () => import("../views/stakeholders/international-orgs")},

  // Partnership Management Routes
  {
    path: "/partnerships/mous",
    name: "mous",
    meta: { title: "MOUs & Agreements", authRequired: true },
    component: () => import("../views/partnerships/mous")},
  {
    path: "/partnerships/funding-partnerships",
    name: "funding-partnerships",
    meta: { title: "Funding Partnerships", authRequired: true },
    component: () => import("../views/partnerships/funding-partnerships")},
  {
    path: "/partnerships/collaboration-tracking",
    name: "collaboration-tracking",
    meta: { title: "Collaboration Tracking", authRequired: true },
    component: () => import("../views/partnerships/collaboration-tracking")},

  // Policy & Governance Routes
  {
    path: "/policy/national-policies",
    name: "national-policies",
    meta: { title: "National Policies", authRequired: true },
    component: () => import("../views/policy/national-policies")},
  {
    path: "/policy/legal-frameworks",
    name: "legal-frameworks",
    meta: { title: "Legal Frameworks", authRequired: true },
    component: () => import("../views/policy/legal-frameworks")},
  {
    path: "/policy/regulations",
    name: "regulations",
    meta: { title: "Regulations & Guidelines", authRequired: true },
    component: () => import("../views/policy/regulations")},
  {
    path: "/policy/legislations",
    name: "legislations",
    meta: { title: "Legislations", authRequired: true },
    component: () => import("../views/policy/legislations")},
  {
    path: "/policy/international-agreements",
    name: "international-agreements",
    meta: { title: "MEAs (Multilateral Environmental Agreements)", authRequired: true },
    component: () => import("../views/policy/international-agreements")},
  {
    path: "/policy/innovation",
    name: "policy-innovation",
    meta: { title: "Innovation", authRequired: true },
    component: () => import("../views/policy/innovation")},
  {
    path: "/policy/feedback",
    name: "policy-feedback",
    meta: { title: "Feedback", authRequired: true },
    component: () => import("../views/policy/feedback")},
  {
    path: "/policy/compliance-tracking",
    name: "compliance-tracking",
    meta: { title: "Compliance Tracking", authRequired: true },
    component: () => import("../views/policy/compliance-tracking")},
  {
    path: "/policy/policy-gaps",
    name: "policy-gaps",
    meta: { title: "Policy Gap Analysis", authRequired: true },
    component: () => import("../views/policy/policy-gaps")},
  {
    path: "/policy/enforcement-status",
    name: "enforcement-status",
    meta: { title: "Enforcement Status", authRequired: true },
    component: () => import("../views/policy/enforcement-status")},

  // System Administration Routes
  {
    path: "/admin/users",
    name: "admin-users",
    meta: { title: "User Accounts", authRequired: true },
    component: () => import("../views/admin/users")},
  {
    path: "/admin/roles",
    name: "admin-roles",
    meta: { title: "Roles & Permissions", authRequired: true },
    component: () => import("../views/admin/roles")},
  {
    path: "/admin/access-control",
    name: "access-control",
    meta: { title: "Access Control", authRequired: true },
    component: () => import("../views/admin/access-control")},
  {
    path: "/admin/system-settings",
    name: "system-settings",
    meta: { title: "System Settings", authRequired: true },
    component: () => import("../views/admin/system-settings")},
  {
    path: "/admin/data-management",
    name: "data-management",
    meta: { title: "Data Management", authRequired: true },
    component: () => import("../views/admin/data-management")},
  {
    path: "/admin/backup-restore",
    name: "backup-restore",
    meta: { title: "Backup & Restore", authRequired: true },
    component: () => import("../views/admin/backup-restore")},  {
    path: "/admin/audit-logs",
    name: "audit-logs",
    meta: { title: "Audit Logs", authRequired: true },
    component: () => import("../views/admin/audit-logs")},

  // Policy Enum Administration Routes
  {
    path: "/administration/policy-enforcement-types",
    name: "policy-enforcement-types",
    meta: { title: "Policy Enforcement Types", authRequired: true },
    component: () => import("../views/admin/policy-enforcement-types")},
  {
    path: "/administration/policy-enforcement-statuses",
    name: "policy-enforcement-statuses",
    meta: { title: "Policy Enforcement Statuses", authRequired: true },
    component: () => import("../views/admin/policy-enforcement-statuses")},
  {
    path: "/administration/policy-jurisdictions",
    name: "policy-jurisdictions",
    meta: { title: "Policy Jurisdictions", authRequired: true },
    component: () => import("../views/admin/policy-jurisdictions")},
  {
    path: "/administration/policy-reporting-periods",
    name: "policy-reporting-periods",
    meta: { title: "Policy Reporting Periods", authRequired: true },
    component: () => import("../views/admin/policy-reporting-periods")},

  // Settings Management Routes
  {
    path: "/settings/user-roles",
    name: "settings-user-roles",
    meta: { title: "User Roles", authRequired: true },
    component: () => import("../views/settings/user-roles")},
  {
    path: "/settings/menu-sections",
    name: "settings-menu-sections",
    meta: { title: "Menu Sections", authRequired: true },
    component: () => import("../views/settings/menu-sections")},
  {
    path: "/settings/permission-levels",
    name: "settings-permission-levels",
    meta: { title: "Permission Levels", authRequired: true },
    component: () => import("../views/settings/permission-levels")},
  {
    path: "/settings/setting-types",
    name: "settings-setting-types",
    meta: { title: "Setting Types", authRequired: true },
    component: () => import("../views/settings/setting-types")},
  {
    path: "/settings/species-types",
    name: "settings-species-types",
    meta: { title: "Species Types", authRequired: true },
    component: () => import("../views/settings/species-types")},
  {
    path: "/settings/ecosystem-types",
    name: "settings-ecosystem-types",
    meta: { title: "Ecosystem Types", authRequired: true },
    component: () => import("../views/settings/ecosystem-types")},
  {
    path: "/settings/iucn-status",
    name: "settings-iucn-status",
    meta: { title: "IUCN Status", authRequired: true },
    component: () => import("../views/settings/iucn-status")},  {
    path: "/api-test",
    name: "api-test",
    meta: { title: "API Connection Test", authRequired: false },
    component: () => import("../views/api-test.vue")},
  {
    path: "/settings/population-trends",
    name: "settings-population-trends",
    meta: { title: "Population Trends", authRequired: true },
    component: () => import("../views/settings/population-trends")},
  {
    path: "/settings/threat-types",
    name: "settings-threat-types",
    meta: { title: "Threat Types", authRequired: true },
    component: () => import("../views/settings/threat-types")},  {
    path: "/settings/threat-severities",
    name: "settings-threat-severities",
    meta: { title: "Threat Severities", authRequired: true },
    component: () => import("../views/settings/threat-severities")},
  {
    path: "/settings/prosecution-statuses",
    name: "settings-prosecution-statuses",
    meta: { title: "Prosecution Statuses", authRequired: true },
    component: () => import("../views/settings/prosecution-statuses")},
  {
    path: "/settings/enforcement-statuses",
    name: "settings-enforcement-statuses",
    meta: { title: "Enforcement Statuses", authRequired: true },
    component: () => import("../views/settings/enforcement-statuses")},
  {
    path: "/settings/mining-statuses",
    name: "settings-mining-statuses",
    meta: { title: "Mining Statuses", authRequired: true },
    component: () => import("../views/settings/mining-statuses")},
  {
    path: "/settings/infrastructure-conflict-statuses",
    name: "settings-infrastructure-conflict-statuses",
    meta: { title: "Infrastructure Conflict Statuses", authRequired: true },
    component: () => import("../views/settings/infrastructure-conflict-statuses")},
  {
    path: "/settings/plastic-pollution-types",
    name: "settings-plastic-pollution-types",
    meta: { title: "Plastic Pollution Types", authRequired: true },
    component: () => import("../views/settings/plastic-pollution-types")},
  {
    path: "/settings/water-sources",
    name: "settings-water-sources",
    meta: { title: "Water Sources", authRequired: true },
    component: () => import("../views/settings/water-sources")},
  {
    path: "/settings/water-pan-purposes",
    name: "settings-water-pan-purposes",
    meta: { title: "Water Pan Purposes", authRequired: true },
    component: () => import("../views/settings/water-pan-purposes")},
  {
    path: "/settings/water-levels",
    name: "settings-water-levels",
    meta: { title: "Water Levels", authRequired: true },
    component: () => import("../views/settings/water-levels")},
  {
    path: "/settings/water-pan-conditions",
    name: "settings-water-pan-conditions",
    meta: { title: "Water Pan Conditions", authRequired: true },
    component: () => import("../views/settings/water-pan-conditions")},
  {
    path: "/settings/usage-frequencies",
    name: "settings-usage-frequencies",
    meta: { title: "Usage Frequencies", authRequired: true },
    component: () => import("../views/settings/usage-frequencies")},
  {
    path: "/settings/all-enums",
    name: "settings-all-enums",
    meta: { title: "All Enums", authRequired: true },
    component: () => import("../views/settings/all-enums")},
    
  // New Enum Management Routes
  {
    path: "/settings/poaching-methods",
    name: "settings-poaching-methods",
    meta: { title: "Poaching Methods", authRequired: true },
    component: () => import("../views/settings/poaching-methods.vue")},
  {
    path: "/settings/poaching-incident-statuses",
    name: "settings-poaching-incident-statuses",
    meta: { title: "Poaching Incident Statuses", authRequired: true },
    component: () => import("../views/settings/poaching-incident-statuses.vue")},
  {
    path: "/settings/bushmeat-actions",
    name: "settings-bushmeat-actions",
    meta: { title: "Bushmeat Actions", authRequired: true },
    component: () => import("../views/settings/bushmeat-actions.vue")},
  {
    path: "/settings/habitat-loss-causes",
    name: "settings-habitat-loss-causes",
    meta: { title: "Habitat Loss Causes", authRequired: true },
    component: () => import("../views/settings/habitat-loss-causes.vue")},
  {
    path: "/settings/distribution-statuses",
    name: "settings-distribution-statuses",
    meta: { title: "Distribution Statuses", authRequired: true },
    component: () => import("../views/settings/distribution-statuses.vue")},
  {
    path: "/settings/threat-levels",
    name: "settings-threat-levels",
    meta: { title: "Threat Levels", authRequired: true },
    component: () => import("../views/settings/threat-levels.vue")},
  {
    path: "/settings/introduction-pathways",
    name: "settings-introduction-pathways",
    meta: { title: "Introduction Pathways", authRequired: true },
    component: () => import("../views/settings/introduction-pathways.vue")},
  {
    path: "/settings/enforcement-priorities",
    name: "settings-enforcement-priorities",
    meta: { title: "Enforcement Priorities", authRequired: true },
    component: () => import("../views/settings/enforcement-priorities.vue")},
  {
    path: "/settings/enforcement-categories",
    name: "settings-enforcement-categories",
    meta: { title: "Enforcement Categories", authRequired: true },
    component: () => import("../views/settings/enforcement-categories.vue")},
  {
    path: "/settings/mining-types",
    name: "settings-mining-types",
    meta: { title: "Mining Types", authRequired: true },
    component: () => import("../views/settings/mining-types.vue")},
  {
    path: "/settings/mineral-types",
    name: "settings-mineral-types",
    meta: { title: "Mineral Types", authRequired: true },
    component: () => import("../views/settings/mineral-types.vue")},
  {
    path: "/settings/climate-indicators",
    name: "settings-climate-indicators",
    meta: { title: "Climate Indicators", authRequired: true },
    component: () => import("../views/settings/climate-indicators.vue")},
  {
    path: "/settings/infrastructure-project-types",
    name: "settings-infrastructure-project-types",
    meta: { title: "Infrastructure Project Types", authRequired: true },
    component: () => import("../views/settings/infrastructure-project-types.vue")},
  {
    path: "/settings/eia-statuses",
    name: "settings-eia-statuses",
    meta: { title: "EIA Statuses", authRequired: true },
    component: () => import("../views/settings/eia-statuses.vue")},
  {
    path: "/settings/counties",
    name: "settings-counties",
    meta: { title: "Counties", authRequired: true },
    component: () => import("../views/settings/counties.vue")},
  {
    path: "/settings/sub-counties",
    name: "settings-sub-counties",
    meta: { title: "Sub-Counties", authRequired: true },
    component: () => import("../views/settings/sub-counties.vue")},
  {
    path: "/settings/wards",
    name: "settings-wards",
    meta: { title: "Wards", authRequired: true },
    component: () => import("../views/settings/wards.vue")},
  {
    path: "/settings/constituencies",
    name: "settings-constituencies",
    meta: { title: "Constituencies", authRequired: true },
    component: () => import("../views/settings/constituencies.vue")},
  
  // Additional missing enum routes
  {
    path: "/settings/area-types",
    name: "settings-area-types",
    meta: { title: "Area Types", authRequired: true },
    component: () => import("../views/settings/area-types.vue")},
  {
    path: "/settings/genders",
    name: "settings-genders",
    meta: { title: "Genders", authRequired: true },
    component: () => import("../views/settings/genders.vue")},
  {
    path: "/settings/arrest-statuses",
    name: "settings-arrest-statuses",
    meta: { title: "Arrest Statuses", authRequired: true },
    component: () => import("../views/settings/arrest-statuses.vue")},
  {
    path: "/settings/pollution-types",
    name: "settings-pollution-types",
    meta: { title: "Pollution Types", authRequired: true },
    component: () => import("../views/settings/pollution-types.vue")},
  {
    path: "/settings/pollution-severities",
    name: "settings-pollution-severities",
    meta: { title: "Pollution Severities", authRequired: true },
    component: () => import("../views/settings/pollution-severities.vue")},
  {
    path: "/settings/pollution-statuses",
    name: "settings-pollution-statuses",
    meta: { title: "Pollution Statuses", authRequired: true },
    component: () => import("../views/settings/pollution-statuses.vue")},
  {
    path: "/settings/habitat-loss-types",
    name: "settings-habitat-loss-types",
    meta: { title: "Habitat Loss Types", authRequired: true },
    component: () => import("../views/settings/habitat-loss-types.vue")},
  {
    path: "/settings/restoration-potentials",
    name: "settings-restoration-potentials",
    meta: { title: "Restoration Potentials", authRequired: true },
    component: () => import("../views/settings/restoration-potentials.vue")},
  {
    path: "/settings/habitat-loss-statuses",
    name: "settings-habitat-loss-statuses",
    meta: { title: "Habitat Loss Statuses", authRequired: true },
    component: () => import("../views/settings/habitat-loss-statuses.vue")},
  {
    path: "/settings/mining-license-statuses",
    name: "settings-mining-license-statuses",
    meta: { title: "Mining License Statuses", authRequired: true },
    component: () => import("../views/settings/mining-license-statuses.vue")},

  // New comprehensive enum management routes
  {
    path: "/settings/access-statuses",
    name: "settings-access-statuses",
    meta: { title: "Access Statuses", authRequired: true },
    component: () => import("../views/settings/access-statuses.vue")},
  {
    path: "/settings/action-statuses",
    name: "settings-action-statuses",
    meta: { title: "Action Statuses", authRequired: true },
    component: () => import("../views/settings/action-statuses.vue")},
  {
    path: "/settings/activity-statuses",
    name: "settings-activity-statuses",
    meta: { title: "Activity Statuses", authRequired: true },
    component: () => import("../views/settings/activity-statuses.vue")},
  {
    path: "/settings/activity-types",
    name: "settings-activity-types",
    meta: { title: "Activity Types", authRequired: true },
    component: () => import("../views/settings/activity-types.vue")},
  {
    path: "/settings/age-groups",
    name: "settings-age-groups",
    meta: { title: "Age Groups", authRequired: true },
    component: () => import("../views/settings/age-groups.vue")},
  {
    path: "/settings/agreement-statuses",
    name: "settings-agreement-statuses",
    meta: { title: "Agreement Statuses", authRequired: true },
    component: () => import("../views/settings/agreement-statuses.vue")},
  {
    path: "/settings/analysis-methods",
    name: "settings-analysis-methods",
    meta: { title: "Analysis Methods", authRequired: true },
    component: () => import("../views/settings/analysis-methods.vue")},
  {
    path: "/settings/analysis-scopes",
    name: "settings-analysis-scopes",
    meta: { title: "Analysis Scopes", authRequired: true },
    component: () => import("../views/settings/analysis-scopes.vue")},
  {
    path: "/settings/areas-of-focus",
    name: "settings-areas-of-focus",
    meta: { title: "Areas of Focus", authRequired: true },
    component: () => import("../views/settings/areas-of-focus.vue")},
  {
    path: "/settings/assessment-types",
    name: "settings-assessment-types",
    meta: { title: "Assessment Types", authRequired: true },
    component: () => import("../views/settings/assessment-types.vue")},
  {
    path: "/settings/attendance-statuses",
    name: "settings-attendance-statuses",
    meta: { title: "Attendance Statuses", authRequired: true },
    component: () => import("../views/settings/attendance-statuses.vue")},
  {
    path: "/settings/club-statuses",
    name: "settings-club-statuses",
    meta: { title: "Club Statuses", authRequired: true },
    component: () => import("../views/settings/club-statuses.vue")},
  {
    path: "/settings/collaboration-statuses",
    name: "settings-collaboration-statuses",
    meta: { title: "Collaboration Statuses", authRequired: true },
    component: () => import("../views/settings/collaboration-statuses.vue")},
  {
    path: "/settings/collaboration-types",
    name: "settings-collaboration-types",
    meta: { title: "Collaboration Types", authRequired: true },
    component: () => import("../views/settings/collaboration-types.vue")},
  {
    path: "/settings/compensation-statuses",
    name: "settings-compensation-statuses",
    meta: { title: "Compensation Statuses", authRequired: true },
    component: () => import("../views/settings/compensation-statuses.vue")},
  {
    path: "/settings/competition-statuses",
    name: "settings-competition-statuses",
    meta: { title: "Competition Statuses", authRequired: true },
    component: () => import("../views/settings/competition-statuses.vue")},
  {
    path: "/settings/competition-types",
    name: "settings-competition-types",
    meta: { title: "Competition Types", authRequired: true },
    component: () => import("../views/settings/competition-types.vue")},
  {
    path: "/settings/compliance-levels",
    name: "settings-compliance-levels",
    meta: { title: "Compliance Levels", authRequired: true },
    component: () => import("../views/settings/compliance-levels.vue")},
  {
    path: "/settings/compliance-statuses",
    name: "settings-compliance-statuses",
    meta: { title: "Compliance Statuses", authRequired: true },
    component: () => import("../views/settings/compliance-statuses.vue")},
  {
    path: "/settings/donor-project-statuses",
    name: "settings-donor-project-statuses",
    meta: { title: "Donor Project Statuses", authRequired: true },
    component: () => import("../views/settings/donor-project-statuses.vue")},
  {
    path: "/settings/economic-component-types",
    name: "settings-economic-component-types",
    meta: { title: "Economic Component Types", authRequired: true },
    component: () => import("../views/settings/economic-component-types.vue")},
  {
    path: "/settings/ecosystem-service-types",
    name: "settings-ecosystem-service-types",
    meta: { title: "Ecosystem Service Types", authRequired: true },
    component: () => import("../views/settings/ecosystem-service-types.vue")},
  {
    path: "/settings/ecosystem-threat-levels",
    name: "settings-ecosystem-threat-levels",
    meta: { title: "Ecosystem Threat Levels", authRequired: true },
    component: () => import("../views/settings/ecosystem-threat-levels.vue")},
  {
    path: "/settings/engagement-types",
    name: "settings-engagement-types",
    meta: { title: "Engagement Types", authRequired: true },
    component: () => import("../views/settings/engagement-types.vue")},
  {
    path: "/settings/event-statuses",
    name: "settings-event-statuses",
    meta: { title: "Event Statuses", authRequired: true },
    component: () => import("../views/settings/event-statuses.vue")},
  {
    path: "/settings/funding-types",
    name: "settings-funding-types",
    meta: { title: "Funding Types", authRequired: true },
    component: () => import("../views/settings/funding-types.vue")},
  {
    path: "/settings/general-statuses",
    name: "settings-general-statuses",
    meta: { title: "General Statuses", authRequired: true },
    component: () => import("../views/settings/general-statuses.vue")},
  {
    path: "/settings/government-levels",
    name: "settings-government-levels",
    meta: { title: "Government Levels", authRequired: true },
    component: () => import("../views/settings/government-levels.vue")},
  {
    path: "/settings/hwc-incident-statuses",
    name: "settings-hwc-incident-statuses",
    meta: { title: "HWC Incident Statuses", authRequired: true },
    component: () => import("../views/settings/hwc-incident-statuses.vue")},
  {
    path: "/settings/hwc-incident-types",
    name: "settings-hwc-incident-types",
    meta: { title: "HWC Incident Types", authRequired: true },
    component: () => import("../views/settings/hwc-incident-types.vue")},
  {
    path: "/settings/implementation-statuses",
    name: "settings-implementation-statuses",
    meta: { title: "Implementation Statuses", authRequired: true },
    component: () => import("../views/settings/implementation-statuses.vue")},
  {
    path: "/settings/infestation-levels",
    name: "settings-infestation-levels",
    meta: { title: "Infestation Levels", authRequired: true },
    component: () => import("../views/settings/infestation-levels.vue")},
  {
    path: "/settings/infrastructure-statuses",
    name: "settings-infrastructure-statuses",
    meta: { title: "Infrastructure Statuses", authRequired: true },
    component: () => import("../views/settings/infrastructure-statuses.vue")},
  {
    path: "/settings/initiative-statuses",
    name: "settings-initiative-statuses",
    meta: { title: "Initiative Statuses", authRequired: true },
    component: () => import("../views/settings/initiative-statuses.vue")},
  {
    path: "/settings/initiative-types",
    name: "settings-initiative-types",
    meta: { title: "Initiative Types", authRequired: true },
    component: () => import("../views/settings/initiative-types.vue")},
  {
    path: "/settings/investigation-statuses",
    name: "settings-investigation-statuses",
    meta: { title: "Investigation Statuses", authRequired: true },
    component: () => import("../views/settings/investigation-statuses.vue")},
  {
    path: "/settings/license-statuses",
    name: "settings-license-statuses",
    meta: { title: "License Statuses", authRequired: true },
    component: () => import("../views/settings/license-statuses.vue")},
  {
    path: "/settings/meeting-statuses",
    name: "settings-meeting-statuses",
    meta: { title: "Meeting Statuses", authRequired: true },
    component: () => import("../views/settings/meeting-statuses.vue")},
  {
    path: "/settings/mitigation-measure-types",
    name: "settings-mitigation-measure-types",
    meta: { title: "Mitigation Measure Types", authRequired: true },
    component: () => import("../views/settings/mitigation-measure-types.vue")},
  {
    path: "/settings/mitigation-methods",
    name: "settings-mitigation-methods",
    meta: { title: "Mitigation Methods", authRequired: true },
    component: () => import("../views/settings/mitigation-methods.vue")},
  {
    path: "/settings/mitigation-statuses",
    name: "settings-mitigation-statuses",
    meta: { title: "Mitigation Statuses", authRequired: true },
    component: () => import("../views/settings/mitigation-statuses.vue")},
  {
    path: "/settings/mou-statuses",
    name: "settings-mou-statuses",
    meta: { title: "MOU Statuses", authRequired: true },
    component: () => import("../views/settings/mou-statuses.vue")},
  {
    path: "/settings/mou-types",
    name: "settings-mou-types",
    meta: { title: "MOU Types", authRequired: true },
    component: () => import("../views/settings/mou-types.vue")},
  {
    path: "/settings/ngo-types",
    name: "settings-ngo-types",
    meta: { title: "NGO Types", authRequired: true },
    component: () => import("../views/settings/ngo-types.vue")},
  {
    path: "/settings/organization-types",
    name: "settings-organization-types",
    meta: { title: "Organization Types", authRequired: true },
    component: () => import("../views/settings/organization-types.vue")},
  {
    path: "/settings/outreach-statuses",
    name: "settings-outreach-statuses",
    meta: { title: "Outreach Statuses", authRequired: true },
    component: () => import("../views/settings/outreach-statuses.vue")},
  {
    path: "/settings/partnership-statuses",
    name: "settings-partnership-statuses",
    meta: { title: "Partnership Statuses", authRequired: true },
    component: () => import("../views/settings/partnership-statuses.vue")},
  {
    path: "/settings/partnership-types",
    name: "settings-partnership-types",
    meta: { title: "Partnership Types", authRequired: true },
    component: () => import("../views/settings/partnership-types.vue")},
  {
    path: "/settings/permit-statuses",
    name: "settings-permit-statuses",
    meta: { title: "Permit Statuses", authRequired: true },
    component: () => import("../views/settings/permit-statuses.vue")},
  {
    path: "/settings/policy-conflict-statuses",
    name: "settings-policy-conflict-statuses",
    meta: { title: "Policy Conflict Statuses", authRequired: true },
    component: () => import("../views/settings/policy-conflict-statuses.vue")},
  {
    path: "/settings/policy-document-types",
    name: "settings-policy-document-types",
    meta: { title: "Policy Document Types", authRequired: true },
    component: () => import("../views/settings/policy-document-types.vue")},
  {
    path: "/settings/policy-scopes",
    name: "settings-policy-scopes",
    meta: { title: "Policy Scopes", authRequired: true },
    component: () => import("../views/settings/policy-scopes.vue")},
  {
    path: "/settings/policy-statuses",
    name: "settings-policy-statuses",
    meta: { title: "Policy Statuses", authRequired: true },
    component: () => import("../views/settings/policy-statuses.vue")},
  {
    path: "/settings/policy-types",
    name: "settings-policy-types",
    meta: { title: "Policy Types", authRequired: true },
    component: () => import("../views/settings/policy-types.vue")},
  {
    path: "/settings/priority-levels",
    name: "settings-priority-levels",
    meta: { title: "Priority Levels", authRequired: true },
    component: () => import("../views/settings/priority-levels.vue")},
  {
    path: "/settings/program-statuses",
    name: "settings-program-statuses",
    meta: { title: "Program Statuses", authRequired: true },
    component: () => import("../views/settings/program-statuses.vue")},
  {
    path: "/settings/program-types",
    name: "settings-program-types",
    meta: { title: "Program Types", authRequired: true },
    component: () => import("../views/settings/program-types.vue")},
  {
    path: "/settings/project-main-statuses",
    name: "settings-project-main-statuses",
    meta: { title: "Project Main Statuses", authRequired: true },
    component: () => import("../views/settings/project-main-statuses.vue")},
  {
    path: "/settings/project-report-statuses",
    name: "settings-project-report-statuses",
    meta: { title: "Project Report Statuses", authRequired: true },
    component: () => import("../views/settings/project-report-statuses.vue")},
  {
    path: "/settings/project-statuses",
    name: "settings-project-statuses",
    meta: { title: "Project Statuses", authRequired: true },
    component: () => import("../views/settings/project-statuses.vue")},
  {
    path: "/settings/regulation-statuses",
    name: "settings-regulation-statuses",
    meta: { title: "Regulation Statuses", authRequired: true },
    component: () => import("../views/settings/regulation-statuses.vue")},
  {
    path: "/settings/risk-levels",
    name: "settings-risk-levels",
    meta: { title: "Risk Levels", authRequired: true },
    component: () => import("../views/settings/risk-levels.vue")},
  {
    path: "/settings/satisfaction-ratings",
    name: "settings-satisfaction-ratings",
    meta: { title: "Satisfaction Ratings", authRequired: true },
    component: () => import("../views/settings/satisfaction-ratings.vue")},
  {
    path: "/settings/school-levels",
    name: "settings-school-levels",
    meta: { title: "School Levels", authRequired: true },
    component: () => import("../views/settings/school-levels.vue")},
  {
    path: "/settings/sector-types",
    name: "settings-sector-types",
    meta: { title: "Sector Types", authRequired: true },
    component: () => import("../views/settings/sector-types.vue")},
  {
    path: "/settings/stakeholder-categories",
    name: "settings-stakeholder-categories",
    meta: { title: "Stakeholder Categories", authRequired: true },
    component: () => import("../views/settings/stakeholder-categories.vue")},
  {
    path: "/settings/target-audiences",
    name: "settings-target-audiences",
    meta: { title: "Target Audiences", authRequired: true },
    component: () => import("../views/settings/target-audiences.vue")},
  {
    path: "/settings/target-groups",
    name: "settings-target-groups",
    meta: { title: "Target Groups", authRequired: true },
    component: () => import("../views/settings/target-groups.vue")},
  {
    path: "/settings/training-levels",
    name: "settings-training-levels",
    meta: { title: "Training Levels", authRequired: true },
    component: () => import("../views/settings/training-levels.vue")},
  {
    path: "/settings/training-statuses",
    name: "settings-training-statuses",
    meta: { title: "Training Statuses", authRequired: true },
    component: () => import("../views/settings/training-statuses.vue")},
  {
    path: "/settings/training-types",
    name: "settings-training-types",
    meta: { title: "Training Types", authRequired: true },
    component: () => import("../views/settings/training-types.vue")},
  {
    path: "/settings/valuation-methods",
    name: "settings-valuation-methods",
    meta: { title: "Valuation Methods", authRequired: true },
    component: () => import("../views/settings/valuation-methods.vue")},
  {
    path: "/settings/valuation-statuses",
    name: "settings-valuation-statuses",
    meta: { title: "Valuation Statuses", authRequired: true },
    component: () => import("../views/settings/valuation-statuses.vue")},
  {
    path: "/settings/visitor-types",
    name: "settings-visitor-types",
    meta: { title: "Visitor Types", authRequired: true },
    component: () => import("../views/settings/visitor-types.vue")},
  {
    path: "/settings/wildlife-license-types",
    name: "settings-wildlife-license-types",
    meta: { title: "Wildlife License Types", authRequired: true },
    component: () => import("../views/settings/wildlife-license-types.vue")},
  // Additional Legacy Database Routes

  // Additional UI Components Routes
  {
    path: "/ui/media",
    name: "media-object",
    meta: { title: "Media Object", authRequired: true },
    component: () => import("../views/ui/media")},

  // Additional Chart Routes
  {
    path: "/charts/apex-line",
    name: "apex-line",
    meta: { title: "Apex Line Charts", authRequired: true },
    component: () => import("../views/charts/apex/line/index")},
  {
    path: "/charts/apex-area",
    name: "apex-area",
    meta: { title: "Apex Area Charts", authRequired: true },
    component: () => import("../views/charts/apex/area/index")},
  {
    path: "/charts/apex-bar",
    name: "apex-bar",
    meta: { title: "Apex Bar Charts", authRequired: true },
    component: () => import("../views/charts/apex/bar/index")},
  {
    path: "/charts/apex-column",
    name: "apex-column",
    meta: { title: "Apex Column Charts", authRequired: true },
    component: () => import("../views/charts/apex/column/index")},
  {
    path: "/charts/apex-mixed",
    name: "apex-mixed",
    meta: { title: "Apex Mixed Charts", authRequired: true },
    component: () => import("../views/charts/apex/mixed/index")},
  {    path: "/charts/apex-range-area",
    name: "apex-range-area",
    meta: { title: "Apex Range Area Charts", authRequired: true },
    component: () => import("../views/charts/apex/rangearea/index")},
  {
    path: "/charts/apex-bubble",
    name: "apex-bubble",
    meta: { title: "Apex Bubble Charts", authRequired: true },
    component: () => import("../views/charts/apex/bubble/index")},
  {
    path: "/charts/apex-scatter",
    name: "apex-scatter",
    meta: { title: "Apex Scatter Charts", authRequired: true },
    component: () => import("../views/charts/apex/scatter/index")},
  {
    path: "/charts/apex-heatmap",
    name: "apex-heatmap",
    meta: { title: "Apex Heatmap Charts", authRequired: true },
    component: () => import("../views/charts/apex/heatmap/index")},
  {
    path: "/charts/apex-treemap",
    name: "apex-treemap",
    meta: { title: "Apex Treemap Charts", authRequired: true },
    component: () => import("../views/charts/apex/treemap/index")},
  {
    path: "/charts/apex-pie",
    name: "apex-pie",
    meta: { title: "Apex Pie Charts", authRequired: true },
    component: () => import("../views/charts/apex/pie/index")},
  {
    path: "/charts/apex-radialbar",
    name: "apex-radialbar",
    meta: { title: "Apex Radialbar Charts", authRequired: true },
    component: () => import("../views/charts/apex/radiabar/index")},
  {
    path: "/charts/apex-radar",
    name: "apex-radar",
    meta: { title: "Apex Radar Charts", authRequired: true },
    component: () => import("../views/charts/apex/radar/index")},
  {
    path: "/charts/apex-polararea",
    name: "apex-polararea",
    meta: { title: "Apex Polararea Charts", authRequired: true },
    component: () => import("../views/charts/apex/polararea/index")},
  {
    path: "/charts/apex-slope",
    name: "apex-slope",
    meta: { title: "Apex Slope Charts", authRequired: true },
    component: () => import("../views/charts/apex/slope/index")},
  {
    path: "/charts/apex-funnel",
    name: "apex-funnel",
    meta: { title: "Apex Funnel Charts", authRequired: true },
    component: () => import("../views/charts/apex/funnel/index")},
  {
    path: "/charts/apex-candlestick",
    name: "apex-candlestick",
    meta: { title: "Apex Candlestick Charts", authRequired: true },
    component: () => import("../views/charts/apex/candlestick/index")},
  {
    path: "/charts/apex-boxplot",
    name: "apex-boxplot",
    meta: { title: "Apex Boxplot Charts", authRequired: true },
    component: () => import("../views/charts/apex/boxplot/index")},

  // Research Module Routes
  {
    path: "/research/ongoing-studies",
    name: "research-ongoing-studies",
    meta: { title: "Ongoing Studies", authRequired: true },
    component: () => import("../views/research/ongoing-studies")},
  {
    path: "/research/publications",
    name: "research-publications",
    meta: { title: "Publications", authRequired: true },
    component: () => import("../views/research/publications")},
  {
    path: "/research/collaboration",
    name: "research-collaboration",
    meta: { title: "Collaboration", authRequired: true },
    component: () => import("../views/research/collaboration")},
  {
    path: "/research/data-collection",
    name: "research-data-collection",
    meta: { title: "Data Collection", authRequired: true },
    component: () => import("../views/research/data-collection")},
  {
    path: "/research/statistical-analysis",
    name: "research-statistical-analysis",
    meta: { title: "Statistical Analysis", authRequired: true },
    component: () => import("../views/research/statistical-analysis")},
  {
    path: "/research/reporting",
    name: "research-reporting",
    meta: { title: "Research Reports", authRequired: true },
    component: () => import("../views/research/reporting")},

  // Reports Module Routes
  {
    path: "/reports/biodiversity-status",
    name: "reports-biodiversity-status",
    meta: { title: "Biodiversity Status", authRequired: true },
    component: () => import("../views/reports/biodiversity-status")},
  {
    path: "/reports/habitat-condition",
    name: "reports-habitat-condition",
    meta: { title: "Habitat Condition", authRequired: true },
    component: () => import("../views/reports/habitat-condition")},
  {
    path: "/reports/species-population",
    name: "reports-species-population",
    meta: { title: "Species Population", authRequired: true },
    component: () => import("../views/reports/species-population")},
  {
    path: "/reports/protected-areas-effectiveness",
    name: "reports-protected-areas-effectiveness",
    meta: { title: "Protected Areas Effectiveness", authRequired: true },
    component: () => import("../views/reports/protected-areas-effectiveness")},
  {
    path: "/reports/conflict-trends",
    name: "reports-conflict-trends",
    meta: { title: "Conflict Trends", authRequired: true },
    component: () => import("../views/reports/conflict-trends")},
  {
    path: "/reports/compensation-analytics",
    name: "reports-compensation-analytics",
    meta: { title: "Compensation Analytics", authRequired: true },
    component: () => import("../views/reports/compensation-analytics")},
  {
    path: "/reports/hotspot-analysis",
    name: "reports-hotspot-analysis",
    meta: { title: "Hotspot Analysis", authRequired: true },
    component: () => import("../views/reports/hotspot-analysis")},
  {
    path: "/reports/mitigation-effectiveness",
    name: "reports-mitigation-effectiveness",
    meta: { title: "Mitigation Effectiveness", authRequired: true },
    component: () => import("../views/reports/mitigation-effectiveness")},
  {
    path: "/reports/tourism-revenue",
    name: "reports-tourism-revenue",
    meta: { title: "Tourism Revenue", authRequired: true },
    component: () => import("../views/reports/tourism-revenue")},
  {
    path: "/reports/ecosystem-valuation",
    name: "reports-ecosystem-valuation",
    meta: { title: "Ecosystem Valuation", authRequired: true },
    component: () => import("../views/reports/ecosystem-valuation")},
  {
    path: "/reports/economic-impact",
    name: "reports-economic-impact",
    meta: { title: "Economic Impact", authRequired: true },
    component: () => import("../views/reports/economic-impact")},
  {
    path: "/reports/crime-statistics",
    name: "reports-crime-statistics",
    meta: { title: "Crime Statistics", authRequired: true },
    component: () => import("../views/reports/crime-statistics")},
  {
    path: "/reports/environmental-threats",
    name: "reports-environmental-threats",
    meta: { title: "Environmental Threats", authRequired: true },
    component: () => import("../views/reports/environmental-threats")},
  {
    path: "/reports/enforcement-metrics",
    name: "reports-enforcement-metrics",
    meta: { title: "Enforcement Metrics", authRequired: true },
    component: () => import("../views/reports/enforcement-metrics")},
  {
    path: "/reports/report-builder",
    name: "reports-report-builder",
    meta: { title: "Report Builder", authRequired: true },
    component: () => import("../views/reports/report-builder")},
  {
    path: "/reports/dashboard-designer",
    name: "reports-dashboard-designer",
    meta: { title: "Dashboard Designer", authRequired: true },
    component: () => import("../views/reports/dashboard-designer")},
  {
    path: "/reports/scheduled-reports",
    name: "reports-scheduled-reports",
    meta: { title: "Scheduled Reports", authRequired: true },
    component: () => import("../views/reports/scheduled-reports")},

  // Human-Wildlife Conflict Reports Routes
  {
    path: "/reports/hwc/compensation-system",
    name: "hwc-compensation-system-report",
    meta: { title: "HWC Compensation System Analysis", authRequired: true },
    component: () => import("../views/reports/hwc/compensation-system")},
  {
    path: "/reports/hwc/human-casualties",
    name: "hwc-human-casualties-report",
    meta: { title: "HWC Human Casualties Analysis", authRequired: true },
    component: () => import("../views/reports/hwc/human-casualties")},
  {
    path: "/reports/hwc/mitigation-infrastructure",
    name: "hwc-mitigation-infrastructure-report",
    meta: { title: "HWC Mitigation Infrastructure", authRequired: true },
    component: () => import("../views/reports/hwc/mitigation-infrastructure")},
  {
    path: "/reports/hwc/geographic-intelligence",
    name: "hwc-geographic-intelligence-report",
    meta: { title: "HWC Geographic Intelligence", authRequired: true },
    component: () => import("../views/reports/hwc/geographic-intelligence")},
  {
    path: "/reports/hwc/species-analysis",
    name: "hwc-species-analysis-report",
    meta: { title: "HWC Species Analysis", authRequired: true },
    component: () => import("../views/reports/hwc/species-analysis")},
  {
    path: "/reports/hwc/temporal-analysis",
    name: "hwc-temporal-analysis-report",
    meta: { title: "HWC Temporal Analysis", authRequired: true },
    component: () => import("../views/reports/hwc/temporal-analysis")},
  {
    path: "/reports/hwc/executive-dashboard",
    name: "hwc-executive-dashboard-report",
    meta: { title: "HWC Executive Dashboard", authRequired: true },
    component: () => import("../views/reports/hwc/executive-dashboard")},
  {
    path: "/reports/hwc/comprehensive",
    name: "hwc-comprehensive-report",
    meta: { title: "HWC Comprehensive Report", authRequired: true },
    component: () => import("../views/reports/hwc/comprehensive")}
];
